import axios from "axios";
import store from "@/stores";
import { useAuthStore } from "@/stores/auth";
import { attemptRefresh, clearTokens } from "@/lib/token-manager";

const httpClient = axios.create({
  baseURL: (import.meta as any).env.VITE_APP_BACKEND_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

httpClient.interceptors.request.use(async (request) => {
  if (request.data instanceof FormData) {
    delete request.headers["Content-Type"];
  } else if (!request.headers["Content-Type"]) {
    request.headers["Content-Type"] = "application/json";
  }

  const authStore = useAuthStore();
  if (authStore.impersonatedCreatorId) {
    request.headers["X-Impersonate-Creator-Id"] = authStore.impersonatedCreatorId;
  }

  if (store.state.creatorReferral) {
    request.headers["X-Referrer"] = store.state.creatorReferral || "";
  }

  if (store.state.ip) {
    request.headers["X-Forwarded-For"] =
      store.state.ip +
      (request.headers["X-Forwarded-For"]
        ? `, ${request.headers["X-Forwarded-For"]}`
        : "");
  }

  return request;
});

httpClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.response) {
      return { status: 500 };
    }

    const originalRequest = error.config;

    if (
      error.response.status === 401 &&
      !(originalRequest as any)._retried
    ) {
      (originalRequest as any)._retried = true;
      const refreshed = await attemptRefresh();
      if (refreshed) {
        return httpClient(originalRequest);
      }
      clearTokens();
      const authStore = useAuthStore();
      authStore.clearUser();
      window.location.href = "/";
      return Promise.reject(error);
    }

    if (error.response.status >= 400 && error.response.status < 500) {
      console.log(error.response);
    } else if (error.response.status >= 500) {
      console.log(error.response);
    }
    return error.response;
  },
);

export default httpClient;
